import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { LoginComponent } from './Components/login/login.component';
import { LoginService } from './services/login/login.service';
import { PagerService } from './Services/pager.service';
import { MasterLayoutComponent } from './Components/Layout/MasterLayout.Component';
import { ProfileComponent } from './Components/profile/profile.component';
import { LoginLayoutComponent } from './Components/Layout/LoginLayout.Component';
import { AuthGuard } from './auth.guard';
import { HomeComponent } from './Components/home/home.component';
import { MatSnackBarComponent } from './Components/mat-snack-bar/mat-snack-bar.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { SelectAutocompleteModule } from 'mat-select-autocomplete';
import { ToastrModule } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { OrderModule } from 'ngx-order-pipe';
import { EncryptionDecryptionService } from './Services/encryption-decryption/encryption-decryption.service';
import { ProductConfigComponent } from '../app/Components/adminRights/product-config/product-config.component';
import { DsCostApprovalComponent } from '../app/Components/dsCostApproval/ds-cost-approval.component';
import { CropConfigComponent } from '../app/Components/adminRights/crop-config/crop-config.component';
import { AdditionalRequirmentComponent } from './Components/AdditionalRequirment/addtionalRequirment.component';
import { AnnualRequirmentComponent } from './Components/AnnualRequirment/annualRequirment.component';
import { FinalRequirmentComponent } from './Components/FinalRequirment/finalRequirment.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AnnualRequirementService } from './services/AnnualRequirement/annual-requirement.service';
import { DispatchSDComponent } from './Components/DispatchSD/dispatch-sd.component';
import { DispatchToWarehouseComponent } from './Components/DispatchToWarehouse/dispatch-to-warehouse.component';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
} from '@angular/material';
import { DragDirective } from './drag-drop.directive';
import { InventoryComponent } from './Components/inventory/inventory.component';
import { PackSizeConfigComponent } from './Components/adminRights/pack-size-config/pack-size-config.component';
import { ReminderEmailConfigComponent } from './Components/adminRights/reminder-email-config/reminder-email-config.component';
import { TimelineComponent } from './Components/adminRights/timeline/timeline.component';
import { AdminRightsService } from './Services/AdminRights/admin-rights.service';
import { CalendarModule } from 'primeng/calendar';
import { DemoSampleAllocationComponent } from './Components/demo-sample-allocation/demo-sample-allocation.component';
import { DSDispatchToFieldComponent } from './Components/DSDispatchToField/DS-Dispatch-To-Field.component';
import { FmcToSdComponent } from './Components/fmc-to-sd/fmc-to-sd.component';
import { MisInventoryComponent } from './Components/mis-inventory/mis-inventory.component';
import { DatePipe } from '@angular/common';
import { DSURequirementReportComponent } from './Components/Reports/dsurequirement-report/dsurequirement-report.component';
import { SDAcknowledge } from './Components/SDAcknowledge/sd-acknowledge.component';
import { DemoSampleMisComponent } from './Components/demo-sample-mis/demo-sample-mis.component';



const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    children: [
      { path: '', component: LoginComponent, pathMatch: 'full' },
      { path: 'DSU/Login', component: LoginComponent }
    ]
  },
  {
    path: '',
    component: MasterLayoutComponent,
    children: [
      { path: 'DSU/Dashboard', component: HomeComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/Profile', component: ProfileComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/CropConfiguration', component: CropConfigComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/ProductConfiguration', component: ProductConfigComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/Inventory', component: InventoryComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/PackSizeConfiguration', component: PackSizeConfigComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/Profile', component: ProfileComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/PackSizeConfiguration', component: PackSizeConfigComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/DSCostApproval', component: DsCostApprovalComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/AdditionalRequirement', component: AdditionalRequirmentComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/AnnualRequirement', component: AnnualRequirmentComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/FinalRequirement', component: FinalRequirmentComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/ReminderEmailConfig', component: ReminderEmailConfigComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/TimelineSettings', component: TimelineComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/DemoSampleAllocation', component: DemoSampleAllocationComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      // { path: 'DSU/DSDispatchtoSD', component: DispatchSDComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/DSDispatchtoField', component: DSDispatchToFieldComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/FmcToSd', component: FmcToSdComponent, pathMatch: 'full', canActivate: [AuthGuard] },
     // { path: 'DSU/MISInventory', component: MisInventoryComponent, pathMatch: 'full', canActivate: [AuthGuard] },
     { path: 'DSU/DemoSampleMIS', component:DemoSampleMisComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/DSURequirementReport', component: DSURequirementReportComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/DSDispatchtoWarehouse', component: DispatchToWarehouseComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'DSU/DSSDAcknowledge', component: SDAcknowledge, pathMatch: 'full', canActivate: [AuthGuard] },
    ]
  },
  { path: '**', redirectTo: 'DSU/Login' }
]

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    OrderModule

  ],
 // declarations: [DemoSampleMisComponent],
  // declarations: [DSURequirementReportComponent],
  //declarations: [DemoSampleAllocationComponent],
  // declarations: [ReminderEmailConfigComponent],
  //declarations: [PackSizeConfigComponent],
  //declarations: [ProductConfigComponent, CropConfigComponent]

})
export class DemoMaterialModule { }

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    MatSnackBarComponent,
    MasterLayoutComponent,
    LoginLayoutComponent,
    DragDirective,
    ProfileComponent,
    ProductConfigComponent,
    CropConfigComponent,
    InventoryComponent,
    PackSizeConfigComponent,
    AdditionalRequirmentComponent,
    AnnualRequirmentComponent,
    FinalRequirmentComponent,
    ReminderEmailConfigComponent,
    DsCostApprovalComponent,
    TimelineComponent,
    FinalRequirmentComponent,
    DemoSampleAllocationComponent,
    DispatchSDComponent,
    DSDispatchToFieldComponent,
    FmcToSdComponent,
    MisInventoryComponent,
    DSURequirementReportComponent,
    DispatchToWarehouseComponent,
    SDAcknowledge,
    DemoSampleMisComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpModule,
    MatSnackBarModule,
    NgxPaginationModule,
    HttpClientModule,
    DemoMaterialModule,
    Ng4LoadingSpinnerModule.forRoot(),
    ToastrModule.forRoot(),
    SelectAutocompleteModule,
    ToastrModule.forRoot({ timeOut: 15000,
      preventDuplicates: true,
      maxOpened: 1,
      autoDismiss: true,
      extendedTimeOut:3000 }),
    NgMultiSelectDropDownModule.forRoot(),
    RouterModule.forRoot(routes, { useHash: true }),
    Ng2SearchPipeModule,
    CalendarModule,
  ],
  providers: [LoginService, EncryptionDecryptionService, AuthGuard, MatSnackBarComponent, MatDatepickerModule, PagerService, AnnualRequirementService, AdminRightsService,DatePipe],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
